import { ReactNode } from "react";

export function GroupProvider({ children, ...rest }: { children: ReactNode }) {
  // Here could be components to pre-load group data.
  // https://redux-toolkit.js.org/rtk-query/usage/prefetching

  return <div {...rest}>{children}</div>;
}
